import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import UserStyles from './AddUser.module.css'
import { useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'


function AddUser() {
  // get data from redux
  const name=useSelector((state)=>state.globalData.name);
  const count=useSelector((state)=>state.globalData.notificationCount);
  const dispatch =  useDispatch()


  const location = useLocation()
  const data = location.state
  
  
  const navigate = useNavigate()


  const [userData, setUserData] = useState({
    name: '',
    username: '',
    email: '',
    phoneNumber: '',
    role: 'Admin',
    password: '',
  })


  const handleInputChange = (event) => {
    const { name, value } = event.target
    setUserData({ ...userData, [name]: value })

  
  }
  const handleSubmit = async (event) => {
    event.preventDefault()

    if (userData.name !== '' && userData.username !== '' && userData.email !== '' && userData.phoneNumber !== '' && userData.role !== '' && userData.password !== '') {
      const formDataObj = new FormData()
      formDataObj.append("name", userData.name)
      formDataObj.append("username", userData.username)
      formDataObj.append("email", userData.email)
      formDataObj.append("phoneNumber", userData.phoneNumber)
      formDataObj.append("role", userData.role)
      formDataObj.append("password", userData.password)



      try {
        const userResponse = await axios.post(
          `${process.env.REACT_APP_STEELADMIN}/superAdmin/register`,
          userData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          // this is the snipte for the notification
          dispatch(fetchNotifications())

          dispatch(setNotificationCount({
           count:count+1,
          }))
        // console.log('User Added.')
        // console.log(userResponse)



        alert('User Added.')
        navigate('/userlist')

      } catch (error) {
        // console.error(error)

      }
    }


    else {
      if (userData?.name === '') {
        alert('Please provide the User name.');
        return false;
      } else if (userData.username === '') {
        alert('Please provide the User last name.');
        return false
      } else if (userData.email === '') {
        alert('Please provide the User Email.');
        return false
      } else if (userData.phoneNumber === '') {
        alert('Please provide the User Number.');
        return false
      } else if (userData.role === '') {
        alert('Please provide the User Role.');
        return false
      } else if (userData.password === '') {
        alert('Please provide the Confirm password.');
        return false;
      }
    }
  }
  //   useEffect(()=>{
  //     handleSubmit()
  // },[])
  const [admin, setAdmin] = React.useState('');
  const handleChange = (event) => {
    setAdmin(event.target.value);
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className={UserStyles.UserMainPage} >
      <Box className={UserStyles.UserPage}>

        <Typography variant='h2'>Add user</Typography>

        <form action="" className={UserStyles.editUserForm} onSubmit={handleSubmit}>
          <label className={UserStyles.UserLabel}>First Name</label>
          <Box className={UserStyles.UserDropdown}>
            <input value={userData.name} name="name" className={UserStyles.UserAdmin} onChange={handleInputChange}
              variant="outlined" />
          </Box>

          <label className={UserStyles.UserLabel}> UserName</label>
          <Box className={UserStyles.UserDropdown}>
            <input value={userData.username} name ='username' className={UserStyles.UserAdmin} onChange={handleInputChange}
              variant="outlined" />
          </Box>

          <label className={UserStyles.UserLabel}>Email </label>
          <Box className={UserStyles.UserDropdown}>
            <input value={userData.email} name="email" className={UserStyles.UserAdmin} onChange={handleInputChange}
              variant="outlined" />
          </Box>

          <label className={UserStyles.UserLabel}>Phone no</label>
          <Box className={UserStyles.UserDropdown}>
            <input type='number' value={userData.phoneNumber} name='phoneNumber' onChange={handleInputChange} className={UserStyles.UserAdmin}
              variant="outlined" />
          </Box>

          <label className={UserStyles.UserLabel} >Select roles</label>
          <Box className={UserStyles.UserDropdown} >
            <FormControl size="small" sx={{ minWidth: '100%', borderRadius: '10px' }}>
              <InputLabel id="demo-select-small-label">Role</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
               
                label="admin"
                sx={{ borderRadius: '10px' }}
                onChange={handleChange}
                value={"Admin"}
              >
              
                <MenuItem value={"Admin"}>Admin</MenuItem>
              

              </Select>
            </FormControl>
          </Box> 

          <label className={UserStyles.UserLabel}>Password</label>
          <Box className={UserStyles.UserDropdown}>
            <input value={userData.password} type={showPassword ? 'text' : 'password'} name='password' className={UserStyles.UserAdmin} onChange={handleInputChange}
              id="outlined-basic" variant="outlined"
            />
            {showPassword ? (
              <VisibilityOff
                className={UserStyles.icon}
                onClick={togglePasswordVisibility}
              />
            ) : (
              <Visibility
                className={UserStyles.icon}
                onClick={togglePasswordVisibility}
              />
            )}
          </Box>

          <Box className={UserStyles.btnBox} >
            {/* <Button variant="outlined" sx={{ mr: '5%', textTransform: 'lowercase' }}>Discard</Button> */}
            <Button type='submit' variant="contained">Save changes</Button>
          </Box>
        </form>
      </Box>
    </div>

  );
}

export default AddUser